// Resol la font d'una imatge: base64, URL externa, o fitxer local a assets/que-fem/
export function resolveImg(src) {
  if (!src) return '';
  if (src.startsWith('data:') || src.startsWith('http')) return src;
  return `assets/que-fem/${src}`;
}